import React from "react";
import classNames from "classnames";

import "./Overlay.scss";

export const Overlay = ({
    className,
    children,
    onClick
}) => (
    <div className="overlay">
        <div
            className={classNames(
                "overlay__backdrop",
                className
            )}
            role="presentation"
            onClick={onClick}
        />
        {children}
    </div>
);
